import React from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { deleteCompletionPhoto } from "./completionPhotoApi";

export const CompletionPhotoStrip = ({ photos, urlFor, deleteUrlFor, canDelete, onChanged, onOpen, testId }) => {
  if (!photos?.length) return null;
  const remove = async (p) => {
    if (!window.confirm("Remove this completion photo?")) return;
    try { onChanged(await deleteCompletionPhoto(deleteUrlFor(p))); toast.success("Photo removed"); } catch (e) { toast.error(e.message); }
  };
  return (
    <div className="space-y-1" data-testid={testId}>
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Completion photos</p>
      <div className="flex flex-wrap gap-2">
        {photos.map((p) => (
          <div key={p.id} className="relative">
            <button type="button" onClick={() => onOpen?.(p)} className="block">
              <img src={urlFor(p)} alt="Completion" className="w-16 h-16 rounded-md object-cover border border-green-200" data-testid={`${testId}-img-${p.id}`} />
            </button>
            {canDelete(p) && (
              <button type="button" onClick={() => remove(p)} aria-label="Remove photo" data-testid={`${testId}-remove-${p.id}`}
                className="absolute -top-2 -right-2 bg-white rounded-full shadow p-0.5 text-red-600"><X className="w-3.5 h-3.5" /></button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
